module.exports = __webpack_public_path__ + "media/2.5789b072.mp3";